import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';

import './index.css';

import environment from '@config/environment';
import App from './App';

Sentry.init({
  dsn: environment.SENTRY_DSN,
  environment: environment.ENVIRONMENT,
  release: environment.SENTRY_RELEASE_ID,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: parseFloat(environment.SENTRY_TRACES_SAMPLE_RATE), //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const setSentryUser = ({ userId, name, email }: { userId: string; name: string; email: string; }) => {
  Sentry.setUser({
    id: userId,
    userName: name,
    userEmail: email,
  });
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

export { Sentry, setSentryUser };
